import React, { Component } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import practiceConstants from './practiceConstants';

export default class CategoriesDesktop extends Component {
  constructor(props) {
    super(props);

    this.sliderSettings = {
      autoplay: false,
      swipe: true,
      touchMove: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    };
  }

  static propTypes = {
    onChangeCategory: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.object.isRequired,
  };
  
  setCategory = (category) => {
    this.props.onChangeCategory(category);
  };
  
  next() {
    this.slider.slickNext();
  }

  render() {
    const { categories } = this.props;
    return (
      <div className="box-row -navigating-sections">
        <div className="navigating-sections">
          <div
            className={classnames('navigating-sections-title', { 'current': !this.props.selectedCategory.alias })}
            onClick={this.setCategory.bind(this, practiceConstants.allCategory)}
            style={{ cursor: 'pointer' }}
          >
            {practiceConstants.allCategory.title}
          </div>

          <div className="navigating-sections-main -scrolling">
            <Slider
              {...this.sliderSettings}
              ref={slider => (this.slider = slider)}
              className="navigating-sections-links"
            >
              {categories.map(item => (
                <li key={item.id}>
                  <span className={classnames({ 'current': this.props.selectedCategory.alias === item.alias })} onClick={this.setCategory.bind(this, item)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </Slider>
            <div className="navigating-sections-main-btn-scroll" onClick={() => this.next()} /> 

          </div>
        </div>
      </div>
    );
  }
}